export default __webpack_public_path__ + "static/media/U_wdt_c_cap_2.2d46413f.mp3";